const htmlToText = (text: string) => {
  const div = document.createElement('div');
  div.innerHTML = text.replace(/<li>/g, '<li>• ');

  return div.innerText.replace(/\n\s*\n\s*\n/g, '\n\n');
};

export default htmlToText;
